// libs
import { Record } from "immutable";
import moment from "moment";


const BaseRecord = Record({
  id: null, // string
  index: -1,
  title: null, // string
  subTitle: null, // string
  date: null, // moment
  isHoliday: false,
  isEvent: false,
  isNormal: false,
  detailHtml: null // HTML string
});

export default class CalendarEventItem extends BaseRecord {
  init(data, index) {
    // console.log(index, data);
    const description = data.description ? data.description.replace(/\n/g, "<br>") : null;

    return this.withMutations(s =>
      s.set("index", index)
       .set("id", data.id)
       .set("date", moment(data.start.date))
       .set("title", data.summary)
       .set("subTitle", data.location)
       .set("detailHtml", description)
       .set("isHoliday", data.summary === "定休日" || data.summary === "冬季休業" || data.summary === "臨時休業")
       .set("isEvent", data.summary === "イベント")
       .set("isNormal", data.summary !== "定休日" && data.summary !== "冬季休業" && data.summary !== "臨時休業" && data.summary !== "イベント")
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/CalendarEventItem.js